import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const OilAnalysisPage = withSuspense(
	lazy(async () => await import('./oil-analysis-page.component')),
	PageLoader,
);
